import { useState } from "react";
import TextField from "../Atoms/TextField";
import InputField from "../Atoms/InputField";
import styles from "../../Styles/NoteInput.module.css";

const NoteInput = ({ theme, noteInfo }) => {
  const [noteTitle, setNoteTitle] = useState();
  const [noteBody, setNoteBody] = useState();

  const noteBodyHandler = (info) => {
    setNoteBody(info);
    noteInfo({ title: noteTitle, text: info });
  };

  const noteTitleHandler = (title) => {
    setNoteTitle(title);
    noteInfo({ title: title, text: noteBody });
  };

  return (
    <div className={styles.container}>
      <InputField
        input={noteTitleHandler}
        isNew={true}
        label="Type Your Note Title"
      />
      <TextField
        text={noteBodyHandler}
        description="Type Your Note"
        theme={theme}
      />
    </div>
  );
};

export default NoteInput;
